import { getRamsRevisions } from '../../../HttpRequests/ramsControlCentre'

export const FETCH_REVISIONS_REQUEST = 'RAMS_RECORD_MODAL/FETCH_REVISIONS_REQUEST'
export const FETCH_REVISIONS_SUCCESS = 'RAMS_RECORD_MODAL/FETCH_REVISIONS_SUCCESS'
export const FETCH_REVISIONS_FAILURE = 'RAMS_RECORD_MODAL/FETCH_REVISIONS_FAILURE'

export const fetchRevisions = (ramsRecordId) => (dispatch) => {
  dispatch({ type: FETCH_REVISIONS_REQUEST })

  return getRamsRevisions(ramsRecordId)
    .then((response) => {
      dispatch({
        type: FETCH_REVISIONS_SUCCESS,
        payload: response.data.data || [],
      })
    })
    .catch((error) => {
      dispatch({
        type: FETCH_REVISIONS_FAILURE,
        payload: error,
      })
    })
}
